import { TransactionData } from './transactionUtils';
import { isRefundTransaction } from '../../../utils/transactionDisplay';

export const getTransactionTypeBadge = (transaction: TransactionData): {
  label: string;
  bgColor: string;
  textColor: string;
} | null => {
  const transactionType = transaction.transactionType?.toLowerCase() || '';
  
  if (isRefundTransaction(transaction)) {
    return {
      label: 'Refund',
      bgColor: 'bg-[rgba(0,85,255,0.08)]',
      textColor: 'text-[#0055FF]',
    };
  } else if (transactionType === 'credit') {
    return {
      label: 'Credit',
      bgColor: 'bg-[rgba(33,81,236,0.08)]',
      textColor: 'text-[#0055FF]',
    };
  } else if (transactionType === 'debit') {
    return {
      label: 'Debit',
      bgColor: 'bg-[rgba(8,155,25,0.08)]',
      textColor: 'text-[#089B19]',
    };
  }
  
  return null;
};

